import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/http'

// LIST ALL FORMATS
export const formatList = (params = '') => Http.get(`/marketing-ad-formats${serialize(params)}`)
export const formatCreate = (params = '') => Http.post('/marketing-ad-formats', params)
export const formatByID = (params = '') => Http.get(`/marketing-ad-formats/${params}`)
export const formatUpdate = (params = '') => Http.put(`/marketing-ad-formats/${params.id}`, params)
export const formatDestroy = (params = '') => Http.delete(`/marketing-ad-formats/${params.id}`)
